// eslint-disable-next-line no-shadow
enum ProductLayout {
  LAYOUT1,
  LAYOUT2,
  LAYOUT3,
  LAYOUT4,
}

export default ProductLayout;
